module.exports = __webpack_public_path__ + "img/SAMESUNG.c22c1c0d.png";